<button matButton="filled" (click)="action.emit()" [disabled]="pending || disabled">
  <ng-content></ng-content>
</button>
